import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Alert, CircularProgress, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { green } from '@mui/material/colors';
import { useRef } from 'react';
import { AvlTable } from '../../Shared/Table/Table';
import { AvlCheckbox } from '../../Shared/Inputs/Checkbox/AvlCheckbox';

export const Columns = {
    name: 'Name',
    action: 'Actions',
    isGoldStandard: 'Gold Standard',
};

function RunsTable(
    {
        onDocumentDelete,
        onDocumentEdit,
        runs,
    },
) {
    const myRefs = useRef([]);
    const myLoadingRefs = useRef([]);

    const handleDelete = async (documentId, index) => {
        myRefs.current[index].style.disabled = true;
        myLoadingRefs.current[index].style.display = 'block';
        myRefs.current[index].style.backgroundColor = 'rgba(25, 118, 210, 0.04)';
        myRefs.current[index].style.color = 'rgba(0, 0, 0, 0.26)';
        myRefs.current[index].style.borderColor = 'rgba(0, 0, 0, 0.26)';

        onDocumentDelete?.(documentId);
    };

    const handleEdit = async (document) => {
        onDocumentEdit?.(document);
    };

    const tableHeaders = [
        {
            label: Columns.isGoldStandard,
            align: 'center',
        },
        {
            label: Columns.name,
            align: 'left',
        },
        {
            label: Columns.action,
            align: 'center',
        },
    ];

    const convertToCells = (row, rowIndex) => [
        {
            style: {
                padding: '0 0 0 56px',
                minWidth: '100px',
            },
            data: row.is_gold_standard && (
                <AvlCheckbox
                    isDisabled
                    value={row.is_gold_standard ?? false}
                />
            ),
        },
        {
            style: {
                width: '100%',
            },
            data: row.name || row.file_name || 'Unknown run',
        },
        {
            style: {
                padding: 0,
            },
            align: 'center',
            data: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box>
                        <Tooltip title="Edit">
                            <span>
                                <IconButton onClick={() => handleEdit(row)}>
                                    <EditIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box >
                    <Box key={`id${row.id}`} sx={{ position: 'relative' }}>
                        <Tooltip title="Delete">
                            <span>
                                <IconButton
                                    id={`button-id${row.id}-delete`}
                                    ref={(el) => (myRefs.current[`id${row.id}`] = el)}
                                    onClick={() => handleDelete(row.id, `id${row.id}`)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <CircularProgress
                            size={24}
                            ref={(el) => (myLoadingRefs.current[`id${row.id}`] = el)}
                            sx={{
                                color: green[500],
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                marginTop: '-12px',
                                marginLeft: '-12px',
                                display: 'none',
                            }}
                        />
                    </Box >
                </div>
            ),
        },
    ];

    const tableRows = runs.map((row, rowIndex) => ({
        cells: convertToCells(row, rowIndex),
    }));

    return runs.length > 0
        ? (
            <AvlTable
                isPaginationDisabled
                headers={tableHeaders}
                rows={tableRows}
            />
        )
        : (
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="warning">Records not found!</Alert>
            </Stack>
        );
}

export default RunsTable;
